import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SortOrder } from '@/components/ui/table'
import { MarketShopInventoryItem, MarketShopInventoryItemStatus } from '@/models'

export type GetMarketShopInventoryRequest = {
  buildingId?: number
  status?: MarketShopInventoryItemStatus
  search?: string
  categoryId?: (number | string)[]
  skip?: number
  limit?: number
  tagId?: number[]
  sort?: string
  order?: SortOrder
}

export type GetMarketShopInventoryResponse = {
  total: number
  data: MarketShopInventoryItem[]
  counts: {
    outOfStock: number
    active: number
    hidden: number
  }
}

export const GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY = 'useGetMarketShopInventory'

export const getMarketShopInventoryQueryKey = (data: GetMarketShopInventoryRequest) => [
  GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY,
  data,
]

export const getMarketShopInventory = async (
  data: GetMarketShopInventoryRequest,
): Promise<GetMarketShopInventoryResponse> => {
  const response = await authAPI.get('/market-shop/inventory', {
    params: data,
  })
  return response.data
}

export const useGetMarketShopInventory = (data: GetMarketShopInventoryRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: () => getMarketShopInventory(data),
    queryKey: getMarketShopInventoryQueryKey(data),
  })
}
